import { createContext } from 'react';

export const ProjectContext = createContext({}); // eslint-disable-line
